import colors from './colors'
import assets from '../assets/'

const components = {
  colors: {
    buttonText: colors.white.n1,
    button: colors.orange.n2,
    font: colors.black.n1,
    navItem: colors.gray.n3,
    link: colors.orange.n2,
    label: colors.gray.n1,
    input: colors.black.n1,
    messageError: colors.red.n1,
    cardText: colors.white.n2,
    transaction: {
      primary: colors.gray.n2,
      secondary: colors.gray.n4,
      line: colors.white.n4
    },
    limitBar: colors.white.n3
  },
  images: {
    logo: assets.images.logo,
    search: assets.images.search,
    avatar: assets.images.avatar,
    warning: assets.images.warning,
    visible: assets.images.visible,
    invisible: assets.images.invisible,
    cardBackground: assets.images.cardBackground,
    opahLogoHorizontal: assets.images.opahLogoHorizontal,
    creditCardLogoBlue: assets.images.creditCardLogoBlue,
    creditCardLogoRose: assets.images.creditCardLogoRose,
    creditCardLogoWhite: assets.images.creditCardLogoWhite,
    cardBackgroundTeuCard: assets.images.cardBackgroundTeuCard,
  },
  icons: { ...assets.icons }
}

export default components
